import {
  SAVE_AVATAR,
  UPDATE_PAYMENT_METHOD,
  NEW_GET_PAYMENT_CONTRACT,
  GET_REACTIVATABLE_MEMBERSHIPS,
  REACTIVATE_REACTIVATABLE_MEMBERSHIPS,
  DELETE_UNAUTHENTICATED_MEMBERSHIP,
  DELETE_SESSION
} from '@/utils/store/actionTypes'
import { formatData } from '@/utils/apollo'
import { apolloClient } from '@/utils/store'
import UpdateAuthUser from '@/apollo/auth_user/UpdateAuthUser.graphql'
import { AUTH_ID } from '@/utils/store/getterTypes'
import { AttributionCookie } from '@/enums/gtm'

export default {
  /**
   * Save user avatar
   *
   * @param rootGetters
   * @param avatar
   * @param userId
   * @returns {Promise<*>}
   */
  async [SAVE_AVATAR] (_, { avatar, userId }) {
    const response = await apolloClient(this).mutate({
      mutation: UpdateAuthUser,
      variables: {
        id: userId,
        avatar
      }
    })

    return formatData(response).data
  },

  /**
   * Submit new payment method.
   *
   * @param rootGetters
   * @returns {Promise<*>}
   * @param paymentContractId
   * @param issuerId
   * @param paymentMethodNonce
   * @param paymentType
   * @param successUrl
   * @param pendingUrl
   * @param failedUrl
   */
  async [UPDATE_PAYMENT_METHOD] ({ rootState, rootGetters }, payload) {
    const userId = rootGetters[`auth/${AUTH_ID}`]

    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${userId}/verification-payment`, {
      ...payload,
      language: rootState.app.locale
    },
    {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [GET_REACTIVATABLE_MEMBERSHIPS] (_, { userId, _hash }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${userId}/members/reactivateable${_hash ? `?_hash=${_hash}` : ''}`,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [REACTIVATE_REACTIVATABLE_MEMBERSHIPS] (_, { userId, _hash, campaignId, memberIds }) {
    const otaAttribution = this.$cookies.get(AttributionCookie)

    if (userId && otaAttribution) {
      const sourceUrl = this.app.router.currentRoute.fullPath
      await this.$axios.$put(`${process.env.API_URL}/v2/users/${userId}/attribution${_hash ? `?_hash=${_hash}` : ''}`, {
        attribution: {
          ...otaAttribution,
          sourceUrl
        }
      }, {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })
    }

    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${userId}/members/reactivateable${_hash ? `?_hash=${_hash}` : ''}`, {
      campaignId,
      memberIds
    },
    {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [NEW_GET_PAYMENT_CONTRACT] (_, { userId, _hash }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${userId}/payment-contract${_hash ? `?_hash=${_hash}` : ''}`,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [DELETE_UNAUTHENTICATED_MEMBERSHIP] (_, variables = {}) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/customer-service/membership-cancellation`, {
      ...variables
    },
    {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [DELETE_SESSION] (_, { token } = {}) {
    const response = await this.$axios.$delete(`${process.env.API_URL}/v2/session`,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      })

    return response
  }
}
